import { DraggableInjectedProps } from './types';

export type DraggableProviderProps = Partial<DraggableInjectedProps> & {
  children?: (injectedProps: DraggableInjectedProps) => React.ReactElement;
};

/**
 * Render as a child of the Draggable component to expose the injected Draggable
 * props as props to a render function.  For example:
 *
 * ```jsx
 * <Draggable>
 *  <DraggableProvider>
 *    {(injectedDraggableProps) => (
 *      <div {...injectedDraggableProps}>
 *         Your content goes here
 *      </div>
 *    )}
 *  </DraggableProvider>
 * </Draggable>
 * ```
 */
function DraggableProvider(props: DraggableProviderProps) {
  const { children, ...injectedProps } = props as DraggableInjectedProps &
    DraggableProviderProps;

  return children(injectedProps);
}

export default DraggableProvider;
